/**
 * A rave in the My raves submenu (the user, 2026-10-29: "should show the logos and then fallback
 * to the name, and the edition at the end"): the rave's logo, else its name, then the edition —
 * "[OZORA logo] 2026". The edition is the edition's name with the festival's name taken off its
 * front ("OZORA Festival 2026" → "2026"); a name that does not start with it is shown whole.
 * The logo is drawn as everywhere else (`LogoArt` — a one-colour SVG takes the text colour).
 */
import { LogoArt } from '@/visitor/Logo';
import './RaveMenuName.css';

export function editionPart(festivalName: string, editionName: string): string {
  const f = festivalName.trim();
  const e = editionName.trim();
  if (f && e.toLocaleLowerCase().startsWith(f.toLocaleLowerCase())) {
    const rest = e.slice(f.length).replace(/^[\s\-–—·:|]+/, '');
    if (rest) return rest;
  }
  return e === f ? '' : e;
}

export function RaveMenuName({ festivalName, editionName, logoUrl }: {
  festivalName: string; editionName: string; logoUrl?: string | null;
}) {
  const edition = editionPart(festivalName, editionName);
  return (
    <span className="rave-menu-name" title={editionName}>
      {logoUrl
        ? <LogoArt src={logoUrl} alt={festivalName} height={18} className="rave-menu-logo" />
        : <span className="rave-menu-festival">{festivalName}</span>}
      {edition && <span className="rave-menu-edition">{edition}</span>}
    </span>
  );
}
